// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsReadDesktopRequest,
  TChatsBulkOperationsReadDesktopModel,
  IMappers,
  TChatsBulkOperationsReadDesktopResponse,
  TChatsBulkOperationsReadDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsReadDesktopModel(
  parameters: TChatsBulkOperationsReadDesktopRequest,
): TChatsBulkOperationsReadDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/read-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsReadDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsReadDesktopRequest;
}

export async function fetchChatsBulkOperationsReadDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsReadDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsReadDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsReadDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsReadDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsReadDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsReadDesktopResponse>;
}
